import { gql } from '@apollo/client';

export const GET_REMITTANCE_NOTES = gql`
  query GetRemittanceNotes($input: GetRemittanceNotesInput!) {
    getRemittanceNotes(input: $input) {
      notes {
        offeringID
        buyerCompanyID
        sellerCompanyID
        noteID
        dealID
        loanID
        fileName
        note
        authorID
        authorRole
        createdAt
        updatedAt
      }
      nextPaginationKey
    }
  }
`;
